<template>
    <div
        class="selectTree"
        :style="{'width':widthCopy==0?`calc(100% - ${lableWidth}px )`:(widthCopy+'px')}"
    >
      <!--   :key="isMultiple?'multiple':'single'" 必须绑定 不然单选切换多选时会出现值清不掉 -->
        <el-select
            v-model="selectValue"
            value-key="code"
            placeholder="请选择"
            :multiple="isMultiple"
            @remove-tag="removeTagHandle"
            clearable
            @clear="clearhandle"
            :disabled="selectDisabled"
            :key="isMultiple?'multiple':'single'"
        >
            <el-option v-model="departmentOptions" class="option-style" disabled  >
                <el-input placeholder="输入关键字" v-model="filterText" clearable >
                    <el-button slot="append" icon="el-icon-search" @click="searchHand"></el-button>
                </el-input>
            </el-option>
            <div class="check-box" v-if="isMultiple&&selectAllBtn">
                <el-checkbox
                    @change="handlecheckAll"
                    class="bidScreenCheckBox"
                    v-model="superviseDeptCodeAll"
                >全选</el-checkbox>
                <!-- <el-button type="text" @click="handleReset">清空</el-button>
                <el-button type="text" @click="handleReverseCheck">反选</el-button>-->
            </div>
            <el-tree
                v-loading="loading"
                ref="deptTreeRef"
                :data="departmentOptions"
                :show-checkbox="isMultiple"
                highlight-current
                :filter-node-method="filterNode"
                node-key="code"
                :key="randomKey"
                :props="deptProps"
                @check="rightTreeHandle"
                @node-click="handleTreeClick"
                @check-change="handleNodeChange"
                accordion
                :check-strictly="type==2?true:false"
            ></el-tree>
        </el-select>
    </div>
</template>

<script>
import { apiGetDeptTree } from "@/server/configPage.js";
export default {
    props: {
        type: {
            type: String,
            default: "1" //表示选择监督部门 2表示赛选所属数据
        },
        modelValue: {
            type: [String, Array],
            default: ""
        },
        isMultiple: {
            type: Boolean,
            default: false
        },
        selectDisabled: {
            type: Boolean,
            default: false
        },
        selectAllBtn: {
            type: Boolean,
            default: false
        },
        widthValue: {
            type: Number,
            default: 0
        },
        lableWidth: {
            type: Number,
            default: 0
        }
    },
    watch: {
        widthValue: {
            immediate: true,
            handler(val) {
                this.widthCopy = val;
                console.log(val, 111);
            }
        }
    },
    data() {
        return {
            loading: false,
            departmentOptions: [],
            deptProps: {
                children: "children",
                label: "name",
                value: "code",
                disabled: (data, node) => {
                    return data.type === "region";
                }
            },
            filterText: "",
            selectValue: "",
            selectTree: "",
            randomKey: Math.random(),
            superviseDeptCodeAll: [],
            isAllCheck: false,
            widthCopy: 0
        };
    },
    watch:{
        filterText:{
            handler(val){
                this.$refs.deptTreeRef.filter(val);
            }
        }
    },
    mounted() {
        if (this.type == "1") {
            this.getTreeOption();
        } else if (this.type == "2") {
            this.getUserTreeOption();
        }
    },
    methods: {
        getTreeOption() {
            this.loading = true;
            apiGetDeptTree()
                .then(res => {
                    if (res.data.code == 1) {
                        let dataInfo = res.data.data;
                        this.departmentOptions = dataInfo;
                        this.loading = false;
                    } else {
                        this.$message.error(rea.data.mag);
                        this.loading = false;
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
                });
        },
        searchHand() {
            this.$refs.deptTreeRef.filter(this.filterText);
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        handleTreeClick(obj, node, checkInfo) {
            console.log(obj, node, checkInfo, 111);
            if (!this.isMultiple) {
                if (
                    obj.type === "region" ||
                    (obj.children && obj.children.length > 0)
                ) {
                    this.$message.info("请选择最后一级节点");
                } else {
                    obj.value = obj.code;
                    obj.label = obj.name;
                    this.selectValue = obj.name;
                    this.$emit("handleDeptType", obj);
                }
            }
        },
        handleNodeChange(obj, objIsChexked, checkInfo) {
            // console.log(obj, objIsChexked, checkInfo, 222);
        },
        rightTreeHandle(item, checkInfo) {
            let checkedNodes = checkInfo.checkedNodes;
            //configType=1默认统计数据权限，2跟多统计权限
            // 过滤掉自动选择的一级父级
            let choseNodeList = checkedNodes.filter(item => {
                return item.type != "region";
            });
            // 单选
            if (!this.isMultiple) {
                this.$refs.deptTreeRef.setCheckedNodes([item]);
                this.filterText = item.name;
                this.$emit("handleDeptType", {
                    value: item.code,
                    label: item.name
                });
            } else {
                // 多选
                let choseItems = [];
                let choseCodes = [];
                let str = "";
                let nameArr = [];
                choseNodeList.forEach((element, index) => {
                    element.value = element.code;
                    element.label = element.name;
                    choseItems.push(element);
                    nameArr.push(element.name);
                    str +=
                        element.name +
                        (index === choseNodeList.length - 1 ? "" : ",");
                });

                //   this.filterText=str
                // this.$emit('update:modelValue',str)
                this.selectValue = [...nameArr];

                this.$emit("handleDeptType", [...choseItems]);
            }
        },
        removeTagHandle(label) {
            //名字
            // 选中项的value
            let selectedValueArray = this.getCheckedNodes()
                .filter(
                    o => o[this.deptProps.label] != label && o.type !== "region"
                )
                .map(o => o);
            // 移除的节点
            let removeNode = this.$refs.deptTreeRef
                .getCheckedNodes(true)
                .filter(o => o[this.deptProps.label] == label);
            // 更新树选中节点
            removeNode.forEach(o => {
                this.$refs.deptTreeRef.setChecked(o, false, true);
            });
            // 更新父组件绑定值
            this.$emit("handleDeptType", [...selectedValueArray]);
        },
        // 获取选中节点
        getCheckedNodes() {
            let onlyLeaf = false;
            return this.$refs.deptTreeRef
                .getCheckedNodes(onlyLeaf)
                .map(node => ({
                    [this.deptProps.label]: node[this.deptProps.label],
                    [this.deptProps.value]: node[this.deptProps.value],
                    type: node.type
                }));
        },
        // // 设置选中节点
        // async setCheckedNodes(selectedArray) {
        //     if (!selectedArray || selectedArray.length == 0) {
        //         this.clear();
        //         return;
        //     }

        //     // 外层"this.$nextTick"处理第一次回显dom可能未加载导致setCheckedKeys报错
        //     this.$nextTick(() => {
        //         this.$refs.tree.setCheckedKeys(selectedArray);
        //     })
        // },

        clearhandle(val, list) {
            this.randomKey = Math.random();

            this.$nextTick(() => {
                // if(  this.$refs.deptTreeRef)this.$refs.deptTreeRef.setCheckedKeys([],false);
            });
            if (!this.isMultiple) {
                this.$emit("handleDeptType", {});
                this.selectValue = "";
            } else {
                this.$emit("handleDeptType", []);
                this.selectValue = [];
            }
        },
        // 全选tree
        handlecheckAll() {
            if (!this.isAllCheck) {
                let flatArr = this.findfunc(this.departmentOptions, [], []);
                this.$refs.deptTreeRef.setCheckedNodes(flatArr.defultCodeArr);
                this.$emit("handleDeptType", [...flatArr.defultCodeArr]);
                this.selectValue = [...flatArr.nameArr];
                this.isAllCheck = true;
            } else {
                this.$refs.deptTreeRef.setCheckedNodes([]);
                this.$emit("handleDeptType", []);
                this.selectValue = [];
                this.isAllCheck = false;
            }
        },
        findfunc(arr, defultCodeArr = [], nameArr = [], myCodes = []) {
            arr.forEach((item, index) => {
                if (myCodes && myCodes.length > 0) {
                    if (myCodes.indexOf(item.code) != -1) {
                        nameArr.push(item.name);
                    }
                    if (item.children && item.children.length > 0) {
                        this.findfunc(
                            item.children,
                            defultCodeArr,
                            nameArr,
                            myCodes
                        );
                    }
                } else {
                    if (item.type !== "region" && !item.children) {
                        defultCodeArr.push(item);
                        nameArr.push(item.name);
                    }
                    if (item.children && item.children.length > 0) {
                        this.findfunc(item.children, defultCodeArr, nameArr);
                    }
                }
            });
            return { defultCodeArr, nameArr };
        },
        // 右侧抽屉选择树
        getUserTreeOption() {
            //this.$store.state.dataDictionary.uerdefultOptionCode
            console.log(this.$store.state.dataDictionary, 2222);
            let uerdefultOptionCode = this.$store.state.dataDictionary
                .uerdefultOptionCode; // 该账户默认选中的值code list
            let uerTreeOption = this.$store.state.dataDictionary.uerTreeOption; // 所有数据
            let defultItemArr = this.$store.state.dataDictionary.defultItemArr; //该账户默认选中的值item list
            this.departmentOptions = uerTreeOption;
            // 设置默认数据源
            this.$nextTick(() => {
                this.$refs.deptTreeRef.setCheckedKeys(
                    uerdefultOptionCode,
                    false
                );
            });
            let nameArr = [];
            defultItemArr.forEach((element, index) => {
                element.value = element.code;
                element.label = element.name;
                nameArr.push(element.name);
            });
            this.selectValue = [...nameArr];
            this.$emit("handleDeptType", [...defultItemArr]);
        },
        // 回显树形数据
        reViewTreeOption(type, value) {
            apiGetDeptTree()
                .then(res => {
                    if (res.data.code == 1) {
                        let dataInfo = res.data.data;
                        let arr = dataInfo;
                        if (type == "code") {
                            // 设置默认数据源
                            this.$nextTick(() => {
                                this.$refs.deptTreeRef.setCheckedKeys(
                                    value,
                                    false
                                );
                            });
                            let obj = this.findfunc(
                                arr,
                                [],
                                [],
                                value
                            );
                            this.selectValue = obj.nameArr;
                        }
                    } else {
                        this.$message.error(rea.data.mag);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }
};
</script>

<style lang="less" scoped>
.bidScreenCheckBox {
    margin-left: 20px;
}
</style>
